module.exports = __webpack_public_path__ + "static/heroBG-0271aba37affc2c8df494670f54b36d2.png";